import { TRTCConnectionInfo } from "../component/trtc/trtc-def"
import { useState } from "react"
import { TRTCCallForm } from "../component/trtc/TRTCCallForm"
import { TRTCCall } from "../component/trtc/TRTCCall"
import { Button, Stack } from "react-bootstrap"
import { useLocation } from "react-router-dom"

export function TRTCTester() {
  const [connectionInfo, setConnectionInfo] = useState<TRTCConnectionInfo>()
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const defaultConnectionInfo = (() => {
    try {
      return JSON.parse(query.get("connectionInfo") ?? "{}")
    } catch (e) {
      console.error(e)
      return undefined
    }
  })()

  return (
    <div className="p-3">
      <Stack>
        <h1>TRTC Call 接続試験</h1>
        {connectionInfo == null ? (
          <TRTCCallForm defaultConnectionInfo={defaultConnectionInfo} handleSubmit={async (e) => setConnectionInfo(e)} />
        ) : (
          <Stack gap={3}>
            <TRTCCall connectionInfo={connectionInfo} />
            <Button variant="danger" onClick={() => setConnectionInfo(undefined)}>
              Disconnect
            </Button>
          </Stack>
        )}
      </Stack>
    </div>
  )
}
